import _pt from "prop-types";import _kebabCase from "lodash/kebabCase";(function () {var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;enterModule && enterModule(module);})();var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {return a;}; /**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';


import { t } from '@superset-ui/core';
import { Tooltip } from './Tooltip';import { jsx as ___EmotionJSX } from "@emotion/react";











export function InfoTooltipWithTrigger({
  label,
  tooltip,
  bsStyle,
  onClick,
  icon = 'info-circle',
  className = 'text-muted',
  placement = 'right' })
{
  const iconClass = `fa fa-${icon} ${className} ${
  bsStyle ? `text-${bsStyle}` : ''
  }`;
  const iconEl =
  ___EmotionJSX("i", {
    role: "button",
    "aria-label": t('Show info tooltip'),
    tabIndex: 0,
    className: iconClass,
    style: { cursor: onClick ? 'pointer' : undefined },
    onClick: onClick,
    onKeyPress:
    onClick && (
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        onClick();
      }
    }) });



  if (!tooltip) {
    return iconEl;
  }
  return (
    ___EmotionJSX(Tooltip, {
      id: `${_kebabCase(label)}-tooltip`,
      title: tooltip,
      placement: placement },

    iconEl));


}InfoTooltipWithTrigger.propTypes = { label: _pt.string, icon: _pt.string, onClick: _pt.func, bsStyle: _pt.string, className: _pt.string };const _default =

InfoTooltipWithTrigger;export default _default;;(function () {var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;if (!reactHotLoader) {return;}reactHotLoader.register(InfoTooltipWithTrigger, "InfoTooltipWithTrigger", "/Users/ville/src/superset-release/superset-frontend/packages/superset-ui-chart-controls/src/components/InfoTooltipWithTrigger.tsx");reactHotLoader.register(_default, "default", "/Users/ville/src/superset-release/superset-frontend/packages/superset-ui-chart-controls/src/components/InfoTooltipWithTrigger.tsx");})();;(function () {var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;leaveModule && leaveModule(module);})();